import { post } from '@/api';
import type { IConfig } from '@/components/forms/interface/IConfig';

export async function getConfigurations(data): Promise<IConfig> {
  return (await post('api/widget', data)).body.data as IConfig;
}
